/* eslint-disable */
import saveStoreDraft from "../../../utils/saveStoreDraft";
import useStoreFormDraft from "../../../hooks/useStoreFormDraft";
import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { applyStoreDraft } from "../../../redux/store/store";
import { db } from "../../../firebase";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { doc } from "firebase/firestore";
import axios from "axios";
import {
  Check,
  RefreshCw,
  Info,
  X,
  AlertCircle,
  Facebook,
  Activity,
  Trash2,
  Plus,
} from "lucide-react";
import apicache from "../../../components/clearCach/clear";
import { useTranslation } from "react-i18next";
import { DHD_PLAN_NAME } from "../../DhdCurrentPlanBanner";

export default function ActivationFacebookPixel({ close }) {
  const { t } = useTranslation();
  const account = useSelector((state) => state.AccountReducer);
  const store = useSelector((state) => state.StoreReducer);
  const products = useSelector((state) => state.ProductsReducer);
  const dispatch = useDispatch();
  const MySwal = withReactContent(Swal);

  const [loading, setLoading] = useState(false);
  const [data, setData] = useStoreFormDraft(store);
  const dynamicFacebookPixels = (data.dynamicFacebookPixels || []).map((value) => ({ value }));
  const setDynamicFacebookPixels = (pixels) => setData((previous) => ({
    ...previous,
    dynamicFacebookPixels: pixels.map((pixel) => pixel.value || ""),
  })); // Initialize the state for dynamic pixels
  const [isPixel1Active, setIsPixel1Active] = useState(false);
  const [isPixel2Active, setIsPixel2Active] = useState(false);
  const [isPixel3Active, setIsPixel3Active] = useState(false);
  const [isPixel4Active, setIsPixel4Active] = useState(false);
  const [pixelUpdateType, setPixelUpdateType] = useState(null);

  useEffect(() => {

     // تحديث البيانات من Redux

    // Check active status for each pixel
    setIsPixel1Active(Boolean(store?.facebookPixel));
    setIsPixel2Active(Boolean(store?.facebookPixel2));
    setIsPixel3Active(Boolean(store?.facebookPixel3));
    setIsPixel4Active(Boolean(store?.facebookPixel4));
  }, [store]);

  // Add SweetAlert styling for z-index
  useEffect(() => {
    // Add CSS to make sure SweetAlert appears on top of other modals
    const style = document.createElement("style");
    style.innerHTML = `
      .swal-container-on-top {
        z-index: 9999999999 !important;
      }
      .swal-backdrop-on-top {
        background: rgba(0,0,0,0.7) !important;
      }
      .swal-popup-on-top {
        position: relative;
        box-shadow: 0 0 20px rgba(0,0,0,0.2);
      }
      body.swal2-shown {
        overflow: hidden;
      }
      body.swal2-shown > [aria-hidden="true"] {
        filter: blur(3px);
      }
    `;
    document.head.appendChild(style);

    // Add a click handler to ensure modal shows on top
    const handleDocumentClick = () => {
      const swalContainer = document.querySelector(".swal2-container");
      if (swalContainer) {
        swalContainer.style.zIndex = "9999999999";
      }
    };

    document.addEventListener("click", handleDocumentClick);

    return () => {
      document.head.removeChild(style);
      document.removeEventListener("click", handleDocumentClick);
    };
  }, []);

  const showAlert = (icon, title, text) => {
    return Swal.fire({
      icon,
      title,
      text,
      confirmButtonText: t(
        "servicePageActivation.servicePageFacebookPixel.alerts.confirm",
      ),
      confirmButtonColor: "rgb(141, 93, 167)",
      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: true,
      backdrop: `
        rgba(0,0,0,0.7)
      `,
      position: "center",
      customClass: {
        popup: "swal-popup-on-top",
        backdrop: "swal-backdrop-on-top",
        container: "swal-container-on-top",
      },
      willOpen: () => {
        // Ensure this alert appears on top of everything
        document.querySelector(".swal2-container").style.zIndex = "9999999999";
      },
    });
  };

  const handlePixelSubmit = async (pixelNumber) => {
    // Set which pixel is being updated
    setPixelUpdateType(pixelNumber);

    // Validate form fields
    if (!data.id) {
      await showAlert(
        "warning",
        t(
          "servicePageActivation.servicePageFacebookPixel.alerts.missingFields.title",
        ),
        t(
          "servicePageActivation.servicePageFacebookPixel.alerts.missingFields.text",
        ),
      );
      console.error("Document ID is missing");
      return;
    }

    try {
      let pixelField = "";
      let pixelValue = "";
      let isDeactivating = false;

      // Determine which pixel is being submitted
      switch (pixelNumber) {
        case 1:
          pixelField = "facebookPixel";
          pixelValue = data.facebookPixel || "";
          isDeactivating = !pixelValue;
          break;
        case 2:
          pixelField = "facebookPixel2";
          pixelValue = data.facebookPixel2 || "";
          isDeactivating = !pixelValue;
          break;
        case 3:
          pixelField = "facebookPixel3";
          pixelValue = data.facebookPixel3 || "";
          isDeactivating = !pixelValue;
          break;
        case 4:
          pixelField = "facebookPixel4";
          pixelValue = data.facebookPixel4 || "";
          isDeactivating = !pixelValue;
          break;
        default:
          // For dynamic pixels
          if (pixelNumber >= 5) {
            const index = pixelNumber - 5;
            isDeactivating = !dynamicFacebookPixels[index]?.value;
          }
      }

      // If main pixel (pixel 1) is being deactivated, check if it's allowed
      if (pixelNumber === 1 && isDeactivating) {
        const result = await showAlert(
          "warning",
          t(
            "servicePageActivation.servicePageFacebookPixel.alerts.deactivateMainPixel.title",
          ),
          t(
            "servicePageActivation.servicePageFacebookPixel.alerts.deactivateMainPixel.text",
          ),
        );

        // If user cancels the confirmation, stop the process
        if (!result.isConfirmed) {
          setPixelUpdateType(null);
          return;
        }
      }

      // Prepare data to save
      apicache(account, products);
      setLoading(true);

      // For dynamic pixels
      if (pixelNumber >= 5) {
        const index = pixelNumber - 5;
        const currentDynamicPixels = [...dynamicFacebookPixels];

        if (isDeactivating) {
          // Remove the pixel
          currentDynamicPixels.splice(index, 1);
        }

        const dataToSave = {
          ...data,
          dynamicFacebookPixels: currentDynamicPixels.map(
            (pixel) => pixel.value || "",
          ),
        };

        await saveStoreDraft(doc(db, "store", data.id), store, dataToSave);
        dispatch(applyStoreDraft(store, dataToSave));
        setDynamicFacebookPixels(currentDynamicPixels);
      } else {
        // For predefined pixels
        if (isDeactivating) {
          // Reset the pixel value to empty
          data[pixelField] = "";
        }

        // Always include dynamicFacebookPixels in the save
        const dataToSave = {
          ...data,
          dynamicFacebookPixels: dynamicFacebookPixels.map(
            (pixel) => pixel.value || "",
          ),
        };

        await saveStoreDraft(doc(db, "store", data.id), store, dataToSave);
        dispatch(applyStoreDraft(store, dataToSave));

        // Update local state to reflect active status
        switch (pixelNumber) {
          case 1:
            setIsPixel1Active(!isDeactivating);
            break;
          case 2:
            setIsPixel2Active(!isDeactivating);
            break;
          case 3:
            setIsPixel3Active(!isDeactivating);
            break;
          case 4:
            setIsPixel4Active(!isDeactivating);
            break;
        }
      }

      setLoading(false);

      // Show success message
      if (isDeactivating) {
        await showAlert(
          "success",
          t(
            "servicePageActivation.servicePageFacebookPixel.alerts.success.deactivatePixel",
          ),
          "",
        );
      } else {
        await showAlert(
          "success",
          t(
            "servicePageActivation.servicePageFacebookPixel.alerts.success.activatePixel",
          ),
          "",
        );
      }
    } catch (error) {
      console.error("Error in handlePixelSubmit:", error);
      setLoading(false);

      await showAlert(
        "error",
        t("servicePageActivation.servicePageFacebookPixel.alerts.error.title"),
        t("servicePageActivation.servicePageFacebookPixel.alerts.error.pixel"),
      );
    } finally {
      setPixelUpdateType(null);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // If no specific pixel is selected, validate all pixels and save
    if (!pixelUpdateType) {
      try {
        // Form validation: Check if the ID exists
        if (!data.id) {
          await showAlert(
            "warning",
            t(
              "servicePageActivation.servicePageFacebookPixel.alerts.missingFields.title",
            ),
            t(
              "servicePageActivation.servicePageFacebookPixel.alerts.missingFields.text",
            ),
          );
          console.error("Document ID is missing");
          return;
        }

        const dataToSave = {
          ...data,
          dynamicFacebookPixels: dynamicFacebookPixels.map(
            (pixel) => pixel.value || "",
          ),
        };

        setLoading(true);
        await saveStoreDraft(doc(db, "store", data.id), store, dataToSave);
        dispatch(applyStoreDraft(store, dataToSave));
        setLoading(false);

        await showAlert(
          "success",
          t(
            "servicePageActivation.servicePageFacebookPixel.alerts.success.save",
          ),
          "",
        );
        close();
      } catch (error) {
        console.error("Error in handleSubmit:", error);
        setLoading(false);

        await showAlert(
          "error",
          t(
            "servicePageActivation.servicePageFacebookPixel.alerts.error.title",
          ),
          t(
            "servicePageActivation.servicePageFacebookPixel.alerts.error.settings",
          ),
        );
      }
    }
  };

  const handleAddPixel = () => {
    setDynamicFacebookPixels([
      ...dynamicFacebookPixels,
      { id: "", value: "" }, // إضافة حقل جديد للبكسل
    ]);
  };

  const removePixel = (index) => {
    if (dynamicFacebookPixels.length > 0) {
      const newPixels = [...dynamicFacebookPixels];
      newPixels.splice(index, 1); // إزالة البكسل عند الفهرس المحدد
      setDynamicFacebookPixels(newPixels);
    }
  };

  const handlePixelChange = (index, event) => {
    const newPixels = [...dynamicFacebookPixels];
    newPixels[index].value = event.target.value;
    setDynamicFacebookPixels(newPixels);
  };

  const clearPixelValue = (pixelNumber) => {
    switch (pixelNumber) {
      case 1:
        setData({ ...data, facebookPixel: "" });
        break;
      case 2:
        setData({ ...data, facebookPixel2: "" });
        break;
      case 3:
        setData({ ...data, facebookPixel3: "" });
        break;
      case 4:
        setData({ ...data, facebookPixel4: "" });
        break;
      default:
        // For dynamic pixels
        if (pixelNumber >= 5) {
          const index = pixelNumber - 5;
          const newPixels = [...dynamicFacebookPixels];
          if (index < newPixels.length) {
            newPixels[index].value = "";
            setDynamicFacebookPixels(newPixels);
          }
        }
    }
  };

  console.log("plan =", account?.subscription?.plan);
  console.log("DHD_PLAN_NAME =", DHD_PLAN_NAME);

  const [addedToPixel, setAddedToPixel] = useState(false); // State for "Events added in Facebook pixel only"
  const [customEvents, setCustomEvents] = useState({
    purchase: false,
    pageView: false,
    viewContent: false,
    addToCart: false,
    initiateCheckout: false,
  });

  // دالة لتحديد أو إلغاء تحديد "الأحداث المضافة في بكسل فيسبوك فقط"
  const handlePixelEventChange = () => {
    const newState = !addedToPixel;
    setAddedToPixel(newState);

    // إذا تم تحديد "الأحداث المضافة في بكسل فيسبوك فقط"، يتم إلغاء تحديد جميع الأحداث الأخرى
    if (newState) {
      setCustomEvents({
        purchase: false,
        pageView: false,
        viewContent: false,
        addToCart: false,
        initiateCheckout: false,
      });
    }
  };

  // دالة لمعالجة تغيير في اختيار الأحداث
  const handleCustomEventChange = (event) => {
    if (addedToPixel) {
      // إذا كانت "الأحداث المضافة في بكسل فيسبوك فقط" محددة، يتم إلغاء تحديد الحدث المخصص
      setCustomEvents({
        ...customEvents,
        [event.target.name]: false, // إلغاء تحديد الحدث المحدد
      });
    } else {
      // تغيير حالة الحدث المخصص بشكل طبيعي
      setCustomEvents({
        ...customEvents,
        [event.target.name]: event.target.checked,
      });
    }
  };

  return (
    <div className="min-h-[400px] h-fit p-6 dark:!bg-[#141414]">
      {/* Page Header */}
      <div className="mb-6">
        <h1 className="text-xl font-bold text-[#9e68ba] dark:!text-[#9e68ba] mb-2 flex items-center">
          <Facebook className="ml-2" size={20} />
          {t("servicePageActivation.servicePageFacebookPixel.title")}
        </h1>
        <p className="text-gray-600 dark:!text-gray-400">
          {t("servicePageActivation.servicePageFacebookPixel.description")}
        </p>
      </div>

      {/* Activation Form */}
      <div className="bg-white dark:!bg-[#181919] rounded-xl shadow-sm border border-[#fbf4ff] dark:!border-[#3c3a3d] p-6 mb-6">
        <form onSubmit={handleSubmit}>
          <div className="mb-6">
            <h3 className="text-lg font-semibold text-[#9e68ba] dark:!text-[#9e68ba] mb-4 flex items-center">
              <Activity className="ml-2" size={18} />
              {t(
                "servicePageActivation.servicePageFacebookPixel.settingsTitle",
              )}
            </h3>

            {/* Main Pixel ID */}
            <div className="mb-5">
              <div className="flex justify-between items-center mb-2">
                <label className="block text-sm font-medium text-gray-700 dark:!text-gray-300">
                  {t("servicePageActivation.servicePageFacebookPixel.pixelId", {
                    index: 1,
                  })}{" "}
                  <span className="text-red-500">*</span>
                </label>
                <div
                  className={`px-2 py-1 rounded-full text-xs font-medium ${
                    isPixel1Active
                      ? "bg-green-100 dark:!bg-green-900 text-green-800 dark:!text-green-200"
                      : "bg-gray-100 dark:!bg-gray-700 text-gray-800 dark:!text-gray-300"
                  }`}
                >
                  {isPixel1Active
                    ? t("servicePageActivation.servicePageFacebookPixel.active")
                    : t(
                        "servicePageActivation.servicePageFacebookPixel.inactive",
                      )}
                </div>
              </div>
              <div className="flex flex-col md:flex-row gap-3">
                <div className="relative flex-grow">
                  <input
                    type="text"
                    placeholder={t(
                      "servicePageActivation.servicePageFacebookPixel.pixelPlaceholder",
                    )}
                    value={data.facebookPixel || ""}
                    onChange={(e) => {
                      const value = e.target.value.replace(/\s+/g, "");
                      setData({ ...data, facebookPixel: value });
                    }}
                    className="w-full px-3 py-2 border border-gray-300 dark:!border-[#3c3a3d] dark:!bg-[#141414] rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-200 focus:border-purple-500 pr-10 dark:!text-gray-300"
                  />
                  {data.facebookPixel && (
                    <button
                      type="button"
                      onClick={() => clearPixelValue(1)}
                      className="absolute left-2 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-red-500 transition-colors w-6 h-6 flex items-center justify-center rounded-full hover:bg-gray-100 dark:hover:!bg-[#3c3a3d]"
                      title={t(
                        "servicePageActivation.servicePageFacebookPixel.clearValue",
                      )}
                    >
                      <X size={16} />
                    </button>
                  )}
                </div>
                <button
                  type="button"
                  onClick={() => handlePixelSubmit(1)}
                  disabled={loading && pixelUpdateType === 1}
                  className={`px-6 py-2.5 ${
                    data.facebookPixel
                      ? "bg-[#9b59bf] hover:bg-[#814a9f]"
                      : "bg-red-500 hover:bg-red-600"
                  } text-white font-medium rounded-lg transition-colors flex items-center justify-center min-w-[120px] ${
                    loading && pixelUpdateType === 1
                      ? "opacity-70 cursor-not-allowed"
                      : ""
                  }`}
                >
                  {loading && pixelUpdateType === 1 ? (
                    <RefreshCw className="animate-spin" size={18} />
                  ) : data.facebookPixel ? (
                    t("servicePageActivation.servicePageFacebookPixel.activate")
                  ) : (
                    t(
                      "servicePageActivation.servicePageFacebookPixel.deactivate",
                    )
                  )}
                </button>
              </div>
              {!isPixel1Active && (
                <p className="text-amber-600 dark:!text-amber-400 text-sm mt-1">
                  {t(
                    "servicePageActivation.servicePageFacebookPixel.pixelNotActive",
                  )}
                </p>
              )}
            </div>

            {/* Second Pixel ID */}
            <div className="mb-5">
              <div className="flex justify-between items-center mb-2">
                <label className="block text-sm font-medium text-gray-700 dark:!text-gray-300">
                  {t("servicePageActivation.servicePageFacebookPixel.pixelId", {
                    index: 2,
                  })}
                  {(account?.subscription?.plan === "الأسطورية" ||
                    account?.subscription?.plan === DHD_PLAN_NAME ||
                    account?.subscription?.plan === "الاحترافية" ||
                    account?.subscription?.plan === "المتطورة") && (
                    <span className="text-red-500">*</span>
                  )}
                </label>
                {(account?.subscription?.plan === "الأسطورية" ||
                  account?.subscription?.plan === DHD_PLAN_NAME ||
                  account?.subscription?.plan === "الاحترافية" ||
                  account?.subscription?.plan === "المتطورة") && (
                  <div
                    className={`px-2 py-1 rounded-full text-xs font-medium ${
                      isPixel2Active
                        ? "bg-green-100 dark:!bg-green-900 text-green-800 dark:!text-green-200"
                        : "bg-gray-100 dark:!bg-gray-700 text-gray-800 dark:!text-gray-300"
                    }`}
                  >
                    {isPixel2Active
                      ? t(
                          "servicePageActivation.servicePageFacebookPixel.active",
                        )
                      : t(
                          "servicePageActivation.servicePageFacebookPixel.inactive",
                        )}
                  </div>
                )}
              </div>
              <div className="flex flex-col md:flex-row gap-3">
                <div className="relative flex-grow">
                  <input
                    type="text"
                    placeholder={t(
                      "servicePageActivation.servicePageFacebookPixel.pixelPlaceholder",
                    )}
                    value={data.facebookPixel2 || ""}
                    onChange={(e) => {
                      const value = e.target.value.replace(/\s+/g, "");
                      setData({ ...data, facebookPixel2: value });
                    }}
                    disabled={
                      account?.subscription?.plan !== "الأسطورية" &&
                      account?.subscription?.plan !== DHD_PLAN_NAME &&
                      account?.subscription?.plan !== "الاحترافية" &&
                      account?.subscription?.plan !== "المتطورة"
                    }
                    className={`w-full px-3 py-2 border border-gray-300 dark:!border-[#3c3a3d] rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-200 focus:border-purple-500 pr-10 dark:!text-gray-300 ${
                      account?.subscription?.plan !== "الأسطورية" &&
                      account?.subscription?.plan !== DHD_PLAN_NAME &&
                      account?.subscription?.plan !== "الاحترافية" &&
                      account?.subscription?.plan !== "المتطورة"
                        ? "bg-gray-100 dark:!bg-[#3c3a3d] cursor-not-allowed"
                        : "dark:!bg-[#141414]"
                    }`}
                  />
                  {data.facebookPixel2 && (
                    <button
                      type="button"
                      onClick={() => clearPixelValue(2)}
                      disabled={
                        account?.subscription?.plan !== "الأسطورية" &&
                        account?.subscription?.plan !== DHD_PLAN_NAME &&
                        account?.subscription?.plan !== "الاحترافية" &&
                        account?.subscription?.plan !== "المتطورة"
                      }
                      className="absolute left-2 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-red-500 transition-colors w-6 h-6 flex items-center justify-center rounded-full hover:bg-gray-100 dark:hover:!bg-[#3c3a3d]"
                      title={t(
                        "servicePageActivation.servicePageFacebookPixel.clearValue",
                      )}
                    >
                      <X size={16} />
                    </button>
                  )}
                </div>
                <button
                  type="button"
                  onClick={() => handlePixelSubmit(2)}
                  disabled={
                    (account?.subscription?.plan !== "الأسطورية" &&
                      account?.subscription?.plan !== DHD_PLAN_NAME &&
                      account?.subscription?.plan !== "الاحترافية" &&
                      account?.subscription?.plan !== "المتطورة") ||
                    (loading && pixelUpdateType === 2)
                  }
                  className={`px-6 py-2.5 ${
                    data.facebookPixel2
                      ? "bg-[#9b59bf] hover:bg-[#814a9f]"
                      : "bg-red-500 hover:bg-red-600"
                  } text-white font-medium rounded-lg transition-colors flex items-center justify-center min-w-[120px] ${
                    (account?.subscription?.plan !== "الأسطورية" &&
                      account?.subscription?.plan !== DHD_PLAN_NAME &&
                      account?.subscription?.plan !== "الاحترافية" &&
                      account?.subscription?.plan !== "المتطورة") ||
                    (loading && pixelUpdateType === 2)
                      ? "opacity-70 cursor-not-allowed"
                      : ""
                  }`}
                >
                  {loading && pixelUpdateType === 2 ? (
                    <RefreshCw className="animate-spin" size={18} />
                  ) : data.facebookPixel2 ? (
                    t("servicePageActivation.servicePageFacebookPixel.activate")
                  ) : (
                    t(
                      "servicePageActivation.servicePageFacebookPixel.deactivate",
                    )
                  )}
                </button>
              </div>
              {account?.subscription?.plan !== "الأسطورية" &&
                account?.subscription?.plan !== DHD_PLAN_NAME &&
                account?.subscription?.plan !== "الاحترافية" &&
                account?.subscription?.plan !== "المتطورة" && (
                  <p className="text-amber-600 dark:!text-amber-400 text-sm mt-1">
                    {t(
                      "servicePageActivation.servicePageFacebookPixel.restrictedPlan2",
                    )}
                  </p>
                )}
            </div>

            {/* Third Pixel ID */}
            <div className="mb-5">
              <div className="flex justify-between items-center mb-2">
                <label className="block text-sm font-medium text-gray-700 dark:!text-gray-300">
                  {t("servicePageActivation.servicePageFacebookPixel.pixelId", {
                    index: 3,
                  })}
                  {(account?.subscription?.plan === "الأسطورية" ||
                    account?.subscription?.plan === DHD_PLAN_NAME ||
                    account?.subscription?.plan === "الاحترافية") && (
                    <span className="text-red-500">*</span>
                  )}
                </label>
                {(account?.subscription?.plan === "الأسطورية" ||
                  account?.subscription?.plan === DHD_PLAN_NAME ||
                  account?.subscription?.plan === "الاحترافية") && (
                  <div
                    className={`px-2 py-1 rounded-full text-xs font-medium ${
                      isPixel3Active
                        ? "bg-green-100 dark:!bg-green-900 text-green-800 dark:!text-green-200"
                        : "bg-gray-100 dark:!bg-gray-700 text-gray-800 dark:!text-gray-300"
                    }`}
                  >
                    {isPixel3Active
                      ? t(
                          "servicePageActivation.servicePageFacebookPixel.active",
                        )
                      : t(
                          "servicePageActivation.servicePageFacebookPixel.inactive",
                        )}
                  </div>
                )}
              </div>
              <div className="flex flex-col md:flex-row gap-3">
                <div className="relative flex-grow">
                  <input
                    type="text"
                    placeholder={t(
                      "servicePageActivation.servicePageFacebookPixel.pixelPlaceholder",
                    )}
                    value={data.facebookPixel3 || ""}
                    onChange={(e) => {
                      const value = e.target.value.replace(/\s+/g, "");
                      setData({ ...data, facebookPixel3: value });
                    }}
                    disabled={
                      account?.subscription?.plan !== "الأسطورية" &&
                      account?.subscription?.plan !== DHD_PLAN_NAME &&
                      account?.subscription?.plan !== "الاحترافية"
                    }
                    className={`w-full px-3 py-2 border border-gray-300 dark:!border-[#3c3a3d] rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-200 focus:border-purple-500 pr-10 dark:!text-gray-300 ${
                      account?.subscription?.plan !== "الأسطورية" &&
                      account?.subscription?.plan !== DHD_PLAN_NAME &&
                      account?.subscription?.plan !== "الاحترافية"
                        ? "bg-gray-100 dark:!bg-[#3c3a3d] cursor-not-allowed"
                        : "dark:!bg-[#141414]"
                    }`}
                  />
                  {data.facebookPixel3 && (
                    <button
                      type="button"
                      onClick={() => clearPixelValue(3)}
                      disabled={
                        account?.subscription?.plan !== "الأسطورية" &&
                        account?.subscription?.plan !== DHD_PLAN_NAME &&
                        account?.subscription?.plan !== "الاحترافية"
                      }
                      className="absolute left-2 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-red-500 transition-colors w-6 h-6 flex items-center justify-center rounded-full hover:bg-gray-100 dark:hover:!bg-[#3c3a3d]"
                      title={t(
                        "servicePageActivation.servicePageFacebookPixel.clearValue",
                      )}
                    >
                      <X size={16} />
                    </button>
                  )}
                </div>
                <button
                  type="button"
                  onClick={() => handlePixelSubmit(3)}
                  disabled={
                    (account?.subscription?.plan !== "الأسطورية" &&
                      account?.subscription?.plan !== DHD_PLAN_NAME &&
                      account?.subscription?.plan !== "الاحترافية") ||
                    (loading && pixelUpdateType === 3)
                  }
                  className={`px-6 py-2.5 ${
                    data.facebookPixel3
                      ? "bg-[#9b59bf] hover:bg-[#814a9f]"
                      : "bg-red-500 hover:bg-red-600"
                  } text-white font-medium rounded-lg transition-colors flex items-center justify-center min-w-[120px] ${
                    (account?.subscription?.plan !== "الأسطورية" &&
                      account?.subscription?.plan !== DHD_PLAN_NAME &&
                      account?.subscription?.plan !== "الاحترافية") ||
                    (loading && pixelUpdateType === 3)
                      ? "opacity-70 cursor-not-allowed"
                      : ""
                  }`}
                >
                  {loading && pixelUpdateType === 3 ? (
                    <RefreshCw className="animate-spin" size={18} />
                  ) : data.facebookPixel3 ? (
                    t("servicePageActivation.servicePageFacebookPixel.activate")
                  ) : (
                    t(
                      "servicePageActivation.servicePageFacebookPixel.deactivate",
                    )
                  )}
                </button>
              </div>
              {account?.subscription?.plan !== "الأسطورية" &&
                account?.subscription?.plan !== DHD_PLAN_NAME &&
                account?.subscription?.plan !== "الاحترافية" && (
                  <p className="text-amber-600 dark:!text-amber-400 text-sm mt-1">
                    {t(
                      "servicePageActivation.servicePageFacebookPixel.restrictedPlan",
                    )}
                  </p>
                )}
            </div>

            {/* Fourth Pixel ID */}
            <div className="mb-5">
              <div className="flex justify-between items-center mb-2">
                <label className="block text-sm font-medium text-gray-700 dark:!text-gray-300">
                  {t("servicePageActivation.servicePageFacebookPixel.pixelId", {
                    index: 4,
                  })}
                  {(account?.subscription?.plan === "الأسطورية" ||
                    account?.subscription?.plan === DHD_PLAN_NAME ||
                    account?.subscription?.plan === "الاحترافية") && (
                    <span className="text-red-500">*</span>
                  )}
                </label>
                {(account?.subscription?.plan === "الأسطورية" ||
                  account?.subscription?.plan === DHD_PLAN_NAME ||
                  account?.subscription?.plan === "الاحترافية") && (
                  <div
                    className={`px-2 py-1 rounded-full text-xs font-medium ${
                      isPixel4Active
                        ? "bg-green-100 dark:!bg-green-900 text-green-800 dark:!text-green-200"
                        : "bg-gray-100 dark:!bg-gray-700 text-gray-800 dark:!text-gray-300"
                    }`}
                  >
                    {isPixel4Active
                      ? t(
                          "servicePageActivation.servicePageFacebookPixel.active",
                        )
                      : t(
                          "servicePageActivation.servicePageFacebookPixel.inactive",
                        )}
                  </div>
                )}
              </div>
              <div className="flex flex-col md:flex-row gap-3">
                <div className="relative flex-grow">
                  <input
                    type="text"
                    placeholder={t(
                      "servicePageActivation.servicePageFacebookPixel.pixelPlaceholder",
                    )}
                    value={data.facebookPixel4 || ""}
                    onChange={(e) => {
                      const value = e.target.value.replace(/\s+/g, "");
                      setData({ ...data, facebookPixel4: value });
                    }}
                    disabled={
                      account?.subscription?.plan !== "الأسطورية" &&
                      account?.subscription?.plan !== DHD_PLAN_NAME &&
                      account?.subscription?.plan !== "الاحترافية"
                    }
                    className={`w-full px-3 py-2 border border-gray-300 dark:!border-[#3c3a3d] rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-200 focus:border-purple-500 pr-10 dark:!text-gray-300 ${
                      account?.subscription?.plan !== "الأسطورية" &&
                      account?.subscription?.plan !== DHD_PLAN_NAME &&
                      account?.subscription?.plan !== "الاحترافية"
                        ? "bg-gray-100 dark:!bg-[#3c3a3d] cursor-not-allowed"
                        : "dark:!bg-[#141414]"
                    }`}
                  />
                  {data.facebookPixel4 && (
                    <button
                      type="button"
                      onClick={() => clearPixelValue(4)}
                      disabled={
                        account?.subscription?.plan !== "الأسطورية" &&
                        account?.subscription?.plan !== DHD_PLAN_NAME &&
                        account?.subscription?.plan !== "الاحترافية"
                      }
                      className="absolute left-2 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-red-500 transition-colors w-6 h-6 flex items-center justify-center rounded-full hover:bg-gray-100 dark:hover:!bg-[#3c3a3d]"
                      title={t(
                        "servicePageActivation.servicePageFacebookPixel.clearValue",
                      )}
                    >
                      <X size={16} />
                    </button>
                  )}
                </div>
                <button
                  type="button"
                  onClick={() => handlePixelSubmit(4)}
                  disabled={
                    (account?.subscription?.plan !== "الأسطورية" &&
                      account?.subscription?.plan !== DHD_PLAN_NAME &&
                      account?.subscription?.plan !== "الاحترافية") ||
                    (loading && pixelUpdateType === 4)
                  }
                  className={`px-6 py-2.5 ${
                    data.facebookPixel4
                      ? "bg-[#9b59bf] hover:bg-[#814a9f]"
                      : "bg-red-500 hover:bg-red-600"
                  } text-white font-medium rounded-lg transition-colors flex items-center justify-center min-w-[120px] ${
                    (account?.subscription?.plan !== "الأسطورية" &&
                      account?.subscription?.plan !== DHD_PLAN_NAME &&
                      account?.subscription?.plan !== "الاحترافية") ||
                    (loading && pixelUpdateType === 4)
                      ? "opacity-70 cursor-not-allowed"
                      : ""
                  }`}
                >
                  {loading && pixelUpdateType === 4 ? (
                    <RefreshCw className="animate-spin" size={18} />
                  ) : data.facebookPixel4 ? (
                    t("servicePageActivation.servicePageFacebookPixel.active")
                  ) : (
                    t("servicePageActivation.servicePageFacebookPixel.inactive")
                  )}
                </button>
              </div>
              {account?.subscription?.plan !== "الأسطورية" &&
                account?.subscription?.plan !== DHD_PLAN_NAME &&
                account?.subscription?.plan !== "الاحترافية" && (
                  <p className="text-amber-600 dark:!text-amber-400 text-sm mt-1">
                    {t(
                      "servicePageActivation.servicePageFacebookPixel.restrictedPlan2",
                    )}
                  </p>
                )}
            </div>

            {/* Dynamic Pixels (only for الأسطورية plan) */}
            {(account?.subscription?.plan === "الأسطورية" ||
              account?.subscription?.plan === DHD_PLAN_NAME) && (
              <>
                {dynamicFacebookPixels.map((pixel, index) => (
                  <div key={index} className="mb-5">
                    <div className="flex justify-between items-center mb-2">
                      <label className="block text-sm font-medium text-gray-700 dark:!text-gray-300">
                        {t(
                          "servicePageActivation.servicePageFacebookPixel.pixelId",
                          { index: index + 5 },
                        )}
                      </label>
                      <div
                        className={`px-2 py-1 rounded-full text-xs font-medium ${
                          pixel.value
                            ? "bg-green-100 dark:!bg-green-900 text-green-800 dark:!text-green-200"
                            : "bg-gray-100 dark:!bg-gray-700 text-gray-800 dark:!text-gray-300"
                        }`}
                      >
                        {pixel.value
                          ? t(
                              "servicePageActivation.servicePageFacebookPixel.active",
                            )
                          : t(
                              "servicePageActivation.servicePageFacebookPixel.inactive",
                            )}
                      </div>
                    </div>
                    <div className="flex flex-col md:flex-row gap-3 items-center">
                      <div className="relative flex-grow">
                        <input
                          type="text"
                          placeholder={t(
                            "servicePageActivation.servicePageFacebookPixel.pixelPlaceholder",
                          )}
                          value={pixel.value || ""}
                          onChange={(e) => handlePixelChange(index, e)}
                          className="w-full px-3 py-2 border border-gray-300 dark:!border-[#3c3a3d] dark:!bg-[#141414] rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-200 focus:border-purple-500 pr-10 dark:!text-gray-300"
                        />
                        {pixel.value && (
                          <button
                            type="button"
                            onClick={() => clearPixelValue(index + 5)}
                            className="absolute left-2 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-red-500 transition-colors w-6 h-6 flex items-center justify-center rounded-full hover:bg-gray-100 dark:hover:!bg-[#3c3a3d]"
                            title={t(
                              "servicePageActivation.servicePageFacebookPixel.clearValue",
                            )}
                          >
                            <X size={16} />
                          </button>
                        )}
                      </div>
                      <button
                        type="button"
                        onClick={() => removePixel(index)}
                        className="p-2 text-red-500 hover:text-red-700 transition-colors"
                      >
                        <Trash2 size={18} />
                      </button>
                      <button
                        type="button"
                        onClick={() => handlePixelSubmit(index + 5)}
                        disabled={loading && pixelUpdateType === index + 5}
                        className={`px-6 py-2.5 ${
                          pixel.value
                            ? "bg-[#9b59bf] hover:bg-[#814a9f]"
                            : "bg-red-500 hover:bg-red-600"
                        } text-white font-medium rounded-lg transition-colors flex items-center justify-center min-w-[120px] ${
                          loading && pixelUpdateType === index + 5
                            ? "opacity-70 cursor-not-allowed"
                            : ""
                        }`}
                      >
                        {loading && pixelUpdateType === index + 5 ? (
                          <RefreshCw className="animate-spin" size={18} />
                        ) : pixel.value ? (
                          t(
                            "servicePageActivation.servicePageFacebookPixel.activate",
                          )
                        ) : (
                          t(
                            "servicePageActivation.servicePageFacebookPixel.deactivate",
                          )
                        )}
                      </button>
                    </div>
                  </div>
                ))}

                {/* Add More Pixels Button */}
                <div className="mt-6 mb-6">
                  <button
                    type="button"
                    onClick={handleAddPixel}
                    className="flex items-center justify-center px-6 py-2.5 bg-[#9b59bf] hover:bg-[#814a9f] text-white font-medium rounded-lg transition-colors gap-2"
                  >
                    <Plus size={18} />
                    <span>
                      {t(
                        "servicePageActivation.servicePageFacebookPixel.addPixel",
                      )}
                    </span>
                  </button>
                </div>
              </>
            )}

            {/* Save All Button */}
            <div className="mt-8">
              <button
                type="submit"
                disabled={loading}
                className={`px-6 py-3 bg-[#9b59bf] hover:bg-[#814a9f] text-white font-medium rounded-lg transition-colors flex items-center ${
                  loading ? "opacity-70 cursor-not-allowed" : ""
                }`}
              >
                {loading ? (
                  <>
                    <RefreshCw className="animate-spin ml-2" size={18} />
                    {t("servicePageActivation.servicePageFacebookPixel.saving")}
                  </>
                ) : (
                  <>
                    <Check className="ml-2" size={18} />
                    {t(
                      "servicePageActivation.servicePageFacebookPixel.saveAll",
                    )}
                  </>
                )}
              </button>
            </div>
          </div>
        </form>
      </div>

      {/* Information Box */}
      <div className="bg-blue-50 dark:!bg-blue-900/20 rounded-xl p-5 border border-blue-100 dark:!border-blue-800/50 mb-6">
        <h3 className="text-lg font-semibold text-blue-800 dark:!text-blue-300 mb-3 flex items-center">
          <AlertCircle className="ml-2" size={18} />
          {t("servicePageActivation.servicePageFacebookPixel.infoTitle")}
        </h3>
        <ul className="list-disc list-inside space-y-2 text-blue-700 dark:!text-blue-300">
          <li>
            {t("servicePageActivation.servicePageFacebookPixel.infoList.item1")}
          </li>
          <li>
            {t("servicePageActivation.servicePageFacebookPixel.infoList.item2")}
          </li>
          <li>
            {t("servicePageActivation.servicePageFacebookPixel.infoList.item3")}
          </li>
          <li>
            {t("servicePageActivation.servicePageFacebookPixel.infoList.item4")}
          </li>
          <li>
            {t("servicePageActivation.servicePageFacebookPixel.infoList.item5")}
          </li>
        </ul>
      </div>
    </div>
  );
}
